<template>
  <svg :filter="filter" :style="definedStyle" :class="svgClass" :stroke="color" :fill="iconFill" aria-hidden="true">
    <use :xlink:href="iconName"/>
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      default: ''
    },
    color:{
      type: String,
      default: 'none'
    },
    filter:{
      type: String,
      default: ''
    },
    definedStyle:{
      type: String|Object,
      default: ''
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`
    },
    // 当 color 为 'none' 时不设置 fill 属性，让 CSS fill: currentColor 生效
    iconFill() {
      return this.color === 'none' ? undefined : this.color
    },
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className
      } else {
        return 'svg-icon'
      }
    }
  }
}
</script>

<style scoped>
.svg-icon{
  width: 1em;
  height: 1em;
  vertical-align: -0.2em;
  fill: currentColor;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/svg-icon/svg-icon.vue